import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import ProductFiltering from "Vue/containers/ProductFiltering.vue";
import LockDesignerWishlist from "Vue/containers/LockDesignerWishlist.vue";
import AccountLoginModal from "Vue/components/lockDesigner/components/shared/Modals/AccountLoginModal.vue";
import AccountRegistrationModal
	from "Vue/components/lockDesigner/components/shared/Modals/AccountRegistrationModal.vue";
import AccountForgotPasswordModal
	from "Vue/components/lockDesigner/components/shared/Modals/AccountForgotPasswordModal.vue";
import AccountResetPasswordModal
	from "Vue/components/lockDesigner/components/shared/Modals/AccountResetPasswordModal.vue";

const routes: Array<RouteRecordRaw> = [
	{
		path: '/products',
		name: "Products",
		component: ProductFiltering,
		props: true
	},
	{
		path: '/sc/:category',
		name: "Container",
		component: ProductFiltering,
		props: true
	},
]



const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;
